import React from 'react';
import {
  RaisedButton,
  FlatButton,
} from 'material-ui';
import OndemandVideoIcon from 'material-ui/svg-icons/notification/ondemand-video';


const ListZeroState = props => {
  const {
    softZero,
    title,
    buttonTitle,
    buttonList,
    videoLink,
    enjoyBenefits,
  } = props;
  if (softZero) {
    return (
      <div
        style={{
          textAlign: 'center',
          margin: '52px auto',
          fontSize: '16px',
          width: '70%',
        }}
      >
        Sorry, we could not find what you are looking for. Please try a
        different search.
      </div>
    );
  }
  const openWhatYouCanDo = () => {
    window.open(videoLink);
  };
  return (
    <div
      style={{
        textAlign: 'center',
        margin: '52px auto',
        width: '70%',
      }}
    >
      <div
        style={{ fontSize: '16px' }}
      >
        {title}
      </div>
      <div
        style={{ marginTop: '16px' }}
      >
        <FlatButton
          secondary
          icon={<OndemandVideoIcon />}
          onClick={openWhatYouCanDo}
          label="See What You Can Do"
        />
      </div>
      <div
        style={{ marginTop: '16px', fontSize: '16px' }}
      >
        {buttonTitle}
      </div>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          marginTop: '8px',
          flexDirection: 'column',
        }}
      >
        {
          buttonList.map(({ label, func }, i) => (
            <RaisedButton
              key={i}
              style={{ marginTop: '12px', width: '290px' }}
              secondary
              label={label}
              onClick={func}
            />
          ))
        }
      </div>
      {
        Boolean(enjoyBenefits && enjoyBenefits.length) && (
          <div style={{ width: '300px', textAlign: 'center', margin: '24px auto', paddingLeft: '25px', fontSize: '12px' }}>
            <div style={{ fontWeight: 'bold' }}>Enjoy the Benefits:</div>
            {
              enjoyBenefits.map((str, i) => (
                <div key={i}>
                  • {str}
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  );
};

export default ListZeroState;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/zero-state.jsx